module.exports = __webpack_public_path__ + "static/media/medband_full.9d3e940a.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/misc/src/medband_full.png
// module id = 563
// module chunks = 0